import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import store from '../../store'
import { Loader } from '../../components/loader';
import Select from 'react-select';
import PhoneInput from 'react-phone-number-input';
import "react-phone-number-input/style.css";
import AvatarEditor from 'react-avatar-editor';
import { getCurrentPetShop, updatePetshop, attachLogo } from '../../actions/petShop';

class BusinessInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingInfo: false,
            loadingLogo: false,
            title: '',
            edit: false,
            changeLogo: false,
            imgSrc: '',
            imgName: '',
            editor: '',
            imageFile: '',
            address:'',
        }

    }

    setEditorRef = (editor) => {
        if(editor) {
          this.setState({editor: editor});
        }
    }

    changeVal = (event) => {
        this.setState({[event.target.name]: event.target.value})
    }

    changeCountry = (event) => {
        this.setState({country: event.value});
    }

    changeLogo = () => {
        this.setState({changeLogo: true});
    }

    editInfo = () => {
        this.setState({
            edit: true,
            title: this.props.petShop.title,
            domain_name: this.props.petShop.domain_name,
            first_name: this.props.petShop.first_name,
            last_name: this.props.petShop.last_name,
            email: this.props.petShop.email,
            phone_number: this.props.petShop.phone_number,
            country: this.props.petShop.country,
            marketing: this.props.petShop.marketing,
            address:this.props.petShop.address,
            website:this.props.petShop.website,
        })
    }

    cancelEditInfo = () => {
        this.setState({edit: false});
    }

    saveInfo = (event) => {
        event.preventDefault();
        this.setState({loadingInfo: true});
        const data = {
            PetShopId: this.props.petShop.id,
            title: this.state.title,
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            email: this.state.email,
            phone_number: this.state.phone_number,
            country: this.state.country,
            marketing: this.state.marketing,
            address: this.state.address,
            website: this.state.website,
        }
    
        if (data.title && data.first_name && data.email && data.phone_number && data.country) {
            this.props.updatePetshop(this.props.petShop.id, data);    
        } else {
            NotificationManager.warning('Incomplete information.');
            this.setState({ loadingInfo: false });
        }
    }

    saveLogo = (event) => {
        event.preventDefault();
        this.setState({loadingLogo: true});
        let formData = new FormData();
        formData.append('file', this.state.imageFile);
        this.props.attachLogo(this.props.petShop.id, formData);
    }

    updatePetshopData = () => {
        const split_1 = window.location.hostname.split('.')[0];
        this.props.getCurrentPetShop(split_1);
    }

    toggleChoice = () => {
        if(this.state.marketing)
            this.setState({marketing: false});
        else
            this.setState({marketing: true});
    }

    _onChange = (event) =>{
        // Assuming only image
        this.setState({imageFile: event.target.files[0]});
        var file = this.refs.file.files[0];
        var reader = new FileReader();
        var url = reader.readAsDataURL(file);
      
         reader.onloadend = function (e) {
            this.setState({
                imgSrc: reader.result,
                imgName: file
            })
          }.bind(this);
        // TODO: concat files
      }

    componentWillReceiveProps = (nextProps) => {
        if(this.props.data.updatePetShop !== nextProps.data.updatePetShop) {
            this.setState({loadingInfo: false, edit: false});
            this.updatePetshopData();
            NotificationManager.success("Information Updated Successfully");
        }
        if(this.props.data.updatePetShopError !== nextProps.data.updatePetShopError) {
            this.setState({loadingInfo: false, edit: false});
            NotificationManager.error("Failed to update Petshop information");
        }

        if(this.props.data.newLogo !== nextProps.data.newLogo) {
            this.setState({loadingLogo: false, changeLogo: false});
            this.updatePetshopData();
            NotificationManager.success("Logo Updated Successfully");
        }
        if(this.props.data.newLogoError !== nextProps.data.newLogoError) {
            this.setState({loadingLogo: false, changeLogo: false});
            NotificationManager.error("Failed to update logo.");
        }
    }

    render() {
        const { title, edit, first_name, last_name, email, phone_number, country, marketing, address, website } = this.state;
        const { petShop } = this.props;
        return (
            <form onSubmit={this.saveInfo} className="m-form">
                
                    <div className="row">
                        <div className="col-xl-8 offset-xl-2">
                            <div className="m-form__section m-form__section--first row">
                                <div className="col-lg-4" style={{alignItems: 'center', display: 'flex'}}>
                                    <div className="row m--align-center">
                                        <div className="mx-auto my-0 col-sm-12">	
                                            {this.state.imgSrc ? 
                                                <img src={this.state.imgSrc} className="m-width-15rem" alt=""/>     
                                            :
                                                <img src={petShop.logo_path ? process.env.REACT_APP_S3_PATH + '/' + petShop.logo_path : "../assets/app/media/img/logos/petpos-logo2.png"} className="m-width-15rem" alt=""/>     
                                            }
                                        </div>
                                        
                                        <div className="m-widget4__info mx-auto my-0 mt-2 col-sm-12">
                                            {this.state.changeLogo ? 
                                                <div className="form-group m-form__group row">
                                                    {/* <label className="col-lg-4 col-form-label">Select Image</label> */}
                                                    <div className="col-lg-12">
                                                        <input 
                                                            ref="file"
                                                            type="file"
                                                            accept="image/*" 
                                                            name="imgName"
                                                            onChange={this._onChange}/>
                                                        
                                                    </div>
                                                    
                                                </div>
                                            :
                                                <button type="button" onClick={() => this.changeLogo()} className="btn btn-link btn-link-no-deco" style={{'width': 'unset'}}>
                                                    <i className="la la-edit"></i>
                                                </button>
                                            }
                                            
                                        </div>
                                        {this.state.imgSrc && 
                                            <div className="m-widget4__info mx-auto my-0 mt-2 col-sm-12">
                                                <button onClick={this.saveLogo} type="button" className="btn m-btn--pill btn-outline-primary"><i className="fas fa-cloud-upload-alt"></i> Save</button>
                                            </div>
                                        }
                                        <div className="m-widget4__title mx-auto my-0 mt-4 col-sm-12">
                                            <span className="m-widget4__title">
                                                {!edit ? petShop.title : title}
                                            </span>
                                        </div>
                                    </div>
                                    {/* <div className="row">
                                        <div className="m-widget4__info mx-auto my-0 mt-2">
                                            <span className="m-widget4__title">
                                                {petShop.title}
                                            </span>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="col-lg-8">
                                    <div className="m-widget4">
                                        <div className="m-widget4__item">
                                            <span className="m-widget4__sub">
                                                <ul className="m-nav m-nav-inline">
                                                    <li className="m-nav__item" style={{display: 'flex', justifyContent: 'flex-end'}}>
                                                        <button type="button" onClick={() => this.editInfo()} className="btn btn-link btn-link-no-deco" style={{'width': 'unset'}}>
                                                            <i className="la la-edit"></i>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </span>
                                        </div>
                                        {!edit ?
                                            <React.Fragment>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-link mr-2"></i>
                                                        <span><strong>Domain name: </strong></span>
                                                        <a href={`${petShop.domain_name}.petpos.com`} target="_blank" className="hyperlink-web">
                                                            {petShop.domain_name}.petpos.com
                                                        </a>
                                                    </span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-user mr-2"></i>
                                                        <span><strong>Owner name: </strong></span>
                                                        {petShop.first_name} {petShop.last_name}
                                                    </span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-at mr-2"></i>
                                                        <span><strong>Email: </strong></span>
                                                        <a href={`mailto:${petShop.email}?body=Hello, ${petShop.first_name}!`} className="hyperlink">
                                                            {petShop.email}
                                                        </a>
                                                    </span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-phone mr-2"></i>
                                                        <span><strong>Phone Number: </strong></span>
                                                        <a href={`tel:${petShop.phone_number}`} className="hyperlink-phone-number">
                                                            {petShop.phone_number}
                                                        </a>
                                                    </span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                    <i className="fas fa-flag mr-2"></i>
                                                        <span><strong>Country: </strong></span>
                                                        {petShop.country}
                                                    </span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                    <i className="fas fa-map-marker-alt mr-2"></i>
                                                        <span><strong>Address: </strong></span>
                                                        {petShop.address?petShop.address:'You have not updated address info.'}
                                                    </span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                    <i className="fas fa-globe mr-2"></i>
                                                        <span><strong>Website: </strong></span>
                                                        {petShop.website?
                                                        <a href={`${petShop.website}`} target="_blank" className="hyperlink-web">
                                                            {petShop.website}
                                                        </a>:'You have not updated website.'}
                                                    </span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <span>{petShop.marketing ? 'You have approved to receive our newsletter' : 'You have disapproved to receive our newsletter'}</span>
                                                    </span>
                                                </div>
                                            </React.Fragment>
                                        :
                                            <React.Fragment>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                                <i className="fas fa-link mr-2"></i>
                                                                <span><strong>Domain name: </strong></span>
                                                                <a href={`${petShop.domain_name}.petpos.com`} target="_blank" className="hyperlink-web">
                                                                    {petShop.domain_name}.petpos.com
                                                                </a>
                                                            </span>
                                                        </div>
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                                <i className="fas fa-store mr-2"></i>
                                                                <span><strong>Business name: </strong></span>
                                                                <input type="text" name="title" value={title} onChange={this.changeVal} className="form-control m-input" placeholder=""/>     
                                                            </span>
                                                        </div>
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                                <i className="fas fa-tag mr-2"></i>
                                                                <span><strong>First name: </strong></span>
                                                                <input type="text" name="first_name" value={first_name} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            </span>
                                                        </div>
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                                <i className="fas fa-tag mr-2"></i>
                                                                <span><strong>Last name: </strong></span>
                                                                <input type="text" name="last_name" value={last_name} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            </span>
                                                        </div>
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                                <i className="fas fa-at mr-2"></i>
                                                                <span><strong>Email: </strong></span>
                                                                <input type="email" name="email" value={email} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            </span>
                                                        </div>
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                                <i className="fas fa-phone mr-2"></i>
                                                                <span><strong>Phone Number: </strong></span>
                                                                <PhoneInput
                                                                    country = {country}
                                                                    className="form-control"
                                                                    placeholder="Enter phone number"
                                                                    value={ phone_number }
                                                                    onChange={ value => this.setState({ 'phone_number': value }) }/>
                                                            </span>
                                                        </div>
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                            <i className="fas fa-flag mr-2"></i>
                                                                <span><strong>Country: </strong></span>
                                                                <Select options={[
                                                                    { value: 'US', label: 'United States' },
                                                                    { value: 'GB', label: 'United Kingdom' },
                                                                    { value: 'LK', label: 'Sri Lanka' }

                                                                ]} value={country} onChange={this.changeCountry} placeholder="Select your country"/>
                                                            </span>
                                                        </div>
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                                <i className="fas fa-map-marker-alt mr-2"></i>
                                                                <span><strong>Address: </strong></span>
                                                                <input type="text" name="address" value={address} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            </span>
                                                        </div>
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                                <i className="fas fa-globe mr-2"></i>
                                                                <span><strong>Website: </strong></span>
                                                                <input type="text" name="website" value={website} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            </span>
                                                        </div>
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                                <label className="m-checkbox m-checkbox--bold m-checkbox--state-success">
                                                                    <input onChange={this.toggleChoice} value={marketing} checked={marketing} type="checkbox" /> Would you like to receive our newsletter?
                                                                    <span></span>
                                                                </label>
                                                            </span>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        
                                                        {!this.state.loadingInfo ?
                                                            <div className="m-widget4__action m--align-right">
                                                                <button onClick={() => this.cancelEditInfo()} type="button" className="btn m-btn--pill btn-secondary mr-2">Cancel</button>
                                                                <button onClick={this.saveInfo} type="button" className="btn m-btn--pill btn-outline-primary">Save</button>
                                                            </div>
                                                        :
                                                            <div className="center-row">
                                                                <Loader size={50} />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        }
                                    </div>
                                
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    
            </form>
        )
    }
}

const mapStateToProps = state => ({
    user: state.cognito.user,
    petShop: state.petShopReducer.currentPetshop,
    data: state.petShopReducer
});

const mapDispatchToProps = dispatch => ({
    getCurrentPetShop: (title) => {
        dispatch(getCurrentPetShop(title));
    },
    updatePetshop: (id, data) => {
        dispatch(updatePetshop(id, data));
    },
    attachLogo: (id, img) => {
        dispatch(attachLogo(id, img));
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BusinessInfo));